jQuery(document).ready(function ($) {
  //Wrap all but first 5 in a div
  //Get number of filter items
  $itemCount = $(
    ".c-accordion--category.main .c-accordion__list .c-accordion__item"
  ).length;
  console.log($itemCount);

  if ($itemCount <= 5) {
    $(".c-accordion--category-more").addClass("hide");
  } else {
    $(".c-accordion--category.main")
      .find(".c-accordion__item")
      .slice(5)
      .wrapAll("<div class='c-accordion--wrapped'></div>");
    //Move the wrapped divs
    $(".c-accordion--wrapped").appendTo(
      ".c-accordion--category-more__item-content"
    );
    //Remove first active
    $(
      ".c-accordion--category-more > .c-accordion__item:first-child"
    ).removeClass("is-active");
    $(".c-accordion--category-more > .c-accordion__item-content").hide();
  }
});
